export type BarrierProviderKind =
  | "stub"
  | "webhook"
  | "magnetic"
  | "hinn"
  | "skidata"
  | "designa"
  | "nedap";

export type LprProviderKind = "generic" | "arnold" | "hikvision" | "axis" | "tattile";

export interface BarrierSettings {
  enabled: boolean;
  provider: BarrierProviderKind;
  base_url: string | null;
  webhook_url: string | null;
  lane_id: string | null;
  open_on_check_in: boolean;
  revoke_on_check_out: boolean;
  sync_whitelist: boolean;
  api_key_configured: boolean;
  api_secret_configured: boolean;
  configured: boolean;
}

export interface LprSettings {
  enabled: boolean;
  provider: LprProviderKind;
  auto_open_barrier: boolean;
  match_checked_in: boolean;
  match_confirmed: boolean;
  api_key_configured: boolean;
  configured: boolean;
  inbound_path: string;
}

export const BARRIER_PROVIDER_OPTIONS: {
  value: BarrierProviderKind;
  label: string;
  hint: string;
}[] = [
  {
    value: "stub",
    label: "Stub (Entwicklung/Test)",
    hint: "Protokolliert Freigaben ohne Hardware – ideal zum Testen.",
  },
  {
    value: "webhook",
    label: "Generischer Webhook",
    hint: "HTTP-POST bei Check-in/Check-out an eine beliebige URL.",
  },
  {
    value: "magnetic",
    label: "Magnetic Autocontrol",
    hint: "MGC-Pro / EM01 über lokales HTTP-Gateway (ModBus-Bridge).",
  },
  {
    value: "hinn",
    label: "Hinn Schrankensteuerung",
    hint: "Tourist-Partner; Anbindung über HTTP-Gateway.",
  },
  {
    value: "skidata",
    label: "SKIDATA",
    hint: "Park-/Zufahrtssysteme über HTTP-Gateway.",
  },
  {
    value: "designa",
    label: "DESIGNA",
    hint: "Parksysteme über HTTP-Gateway.",
  },
  {
    value: "nedap",
    label: "Nedap Access",
    hint: "Zutrittskontrolle über HTTP-Gateway.",
  },
];

export const LPR_PROVIDER_OPTIONS: {
  value: LprProviderKind;
  label: string;
  hint: string;
}[] = [
  {
    value: "generic",
    label: "Generischer Webhook (JSON)",
    hint: "Einheitliches JSON mit license_plate / plate.",
  },
  {
    value: "arnold",
    label: "Arnold Kennzeichenerkennung",
    hint: "Tourist-nahe Felder (kennzeichen, kamera, spur).",
  },
  {
    value: "hikvision",
    label: "Hikvision ANPR",
    hint: "EventNotificationAlert / ANPR-Payload.",
  },
  {
    value: "axis",
    label: "Axis License Plate Verifier",
    hint: "Axis ACAP-Events mit plate/text.",
  },
  {
    value: "tattile",
    label: "Tattile / ARH",
    hint: "OCR-/Plate-Felder typischer Tattile-Kameras.",
  },
];

export function barrierNeedsBaseUrl(provider: BarrierProviderKind): boolean {
  return provider !== "stub" && provider !== "webhook";
}

export function barrierNeedsWebhookUrl(provider: BarrierProviderKind): boolean {
  return provider === "webhook";
}
